import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ProjectTemplatePopup = loadAsyncComponent(() => import('./Container'), 'popup');
